import { useEffect, useState } from "react";
import betaAPI from "v2/api";
import { NO_LABELS, wearableLabels } from "utils/wearableLabels";

/**
 * The number printed on each wearable's case, from one `/v2/wearables/` call
 * (cached by the API client). Returns { forMac, forName }; both give null
 * until it loads, or if it fails (the screens then show names only).
 */
export default function useWearableLabels() {
  const [labels, setLabels] = useState(NO_LABELS);
  useEffect(() => {
    let alive = true;
    betaAPI
      .getWearableLabels()
      .then(({ data }) => alive && setLabels(wearableLabels(data)))
      .catch((e) => console.error("Failed to load wearable labels", e));
    return () => {
      alive = false;
    };
  }, []);
  return labels;
}
